export default __webpack_public_path__ + "static/media/key6.9ab437bd.png";